const toggleResults = (container, items) => {
  const noResults =
    items.filter(item => !item.classList.contains("d-none")).length === 0;
  let message = container.querySelector('.no-results-found');

  if (noResults && !message) {
    message = document.createElement('h5');
    message.innerText = 'No results found';
    message.classList.add('no-results-found');
    container.appendChild(message);
  } else if (!noResults && message) {
    message.remove();
  }
}

const onSearch = (container, query) => {
  const headers = container.querySelectorAll("h5.heading");
  const listGroupItems = container.querySelectorAll(".list-group-item");

  if (query !== '') {
    headers.forEach(header => header.classList.add('d-none'));
  } else {
    headers.forEach(header => header.classList.remove('d-none'));
  }

  listGroupItems.forEach(item => {
    const text = item.innerHTML.toLowerCase();

    if (text.includes(query)) {
      item.classList.remove('d-none');
    } else {
      item.classList.add('d-none');
    }
  })

  toggleResults(container, Array.from(listGroupItems));
}

const initializeSearch = (container) => {
  const input = container.querySelector("input");
  const removeIcon = container.querySelector(".remove-icon");

  removeIcon.addEventListener("click", () => {
    input.value = "";
    onSearch(container, "");
  })

  input.addEventListener('input', event => {
    const query = event.target.value.trim().toLowerCase();
    onSearch(container, query);
  });
}

const attachAll = () => {
  document.querySelectorAll("[data-search='list-group']").forEach((container) => {
    initializeSearch(container);
  });

  const observer = new MutationObserver((mutations) => {
    mutations.filter((m) => m.addedNodes.length > 0).forEach((mutation) => {
      mutation.target.querySelectorAll("[data-search='list-group']").forEach((container) => {
        initializeSearch(container);
      })
    })
  })

  observer.observe(document.body, { childList: true, subtree: true });
}

export default { attachAll }
